import axios from 'axios';
import { httpClient } from '@/api/httpClient';
import { environment } from '@/config/environment';
import {
  mapApiResourceToTokens,
  type AuthenticationTokens,
  type TokenPairApiResource,
} from './authApi.types';

const tokenRefreshHttpClient = axios.create({
  baseURL: environment.apiBaseUrl,
  timeout: environment.apiTimeoutMilliseconds,
  headers: {
    'Content-Type': 'application/json',
  },
});

export async function refreshAuthenticationTokens(
  refreshToken: string
): Promise<AuthenticationTokens> {
  const response = await tokenRefreshHttpClient.post<TokenPairApiResource>('/auth/refresh', {
    refresh_token: refreshToken,
  });
  return mapApiResourceToTokens(response.data);
}

export async function loginWithCredentials(
  email: string,
  password: string
): Promise<AuthenticationTokens> {
  const response = await httpClient.post<TokenPairApiResource>('/auth/login', { email, password });
  return mapApiResourceToTokens(response.data);
}

export async function logoutCurrentSession(): Promise<void> {
  await httpClient.post('/auth/logout');
}

export async function requestPasswordReset(email: string): Promise<void> {
  await httpClient.post('/auth/forgot-password', { email });
}

export async function resetPassword(token: string, password: string): Promise<void> {
  await httpClient.post('/auth/reset-password', { token, password });
}

export async function changePassword(
  currentPassword: string,
  newPassword: string
): Promise<void> {
  await httpClient.post('/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  });
}

export async function requestEmailChange(
  currentPassword: string,
  newEmail: string
): Promise<void> {
  await httpClient.post('/auth/change-email', {
    current_password: currentPassword,
    new_email: newEmail,
  });
}

export async function verifyEmailChange(token: string): Promise<void> {
  await httpClient.post('/auth/verify-email-change', { token });
}

export async function verifyEmailAddress(token: string): Promise<void> {
  await httpClient.post('/auth/verify-email', { token });
}

export async function resendVerificationEmail(): Promise<void> {
  await httpClient.post('/auth/resend-verification-email');
}
